import "./Statistics.scss"
import pointsStatisticsPic from "../../assets/svg/ic-points-statistics.svg"
import CountUp from "../../component/ countUp/CountUp";
import {RaikoBaseCardContainer} from "@moeindal/base-raiko-panel-components";

export default function PointsStatistics(
    {
        title = "",
        amount = 0,
        iconFile = pointsStatisticsPic
    }
) {


    return (
        <RaikoBaseCardContainer className="statisticsContainer">
            <div className="statisticsTitleContainer">
                <div className="statisticsTitleContent">
                    <span className="statisticsGlobalTitle">{title}</span>
                </div>
                {/*<div className="ic-details" />*/}
            </div>
            <span
                className="mainInfo">{

                [0, "0", 'undefined', null].includes(amount) ? "0" :
                    typeof amount === 'number' ?
                        <CountUp end={amount} duration={250}/>
                        : amount
            }</span>
            <div>
                {iconFile && <img src={iconFile} alt="آمار"/>}
            </div>
        </RaikoBaseCardContainer>
    )
}